import { Component, OnInit, Input } from "@angular/core";
import { CtaButtonLayoutInternetSpeedContext } from "./cta-button-layout-internet-speed.models";
import { CTAButtonLayout } from "../cta-button-layout";

@Component({
    selector: "dodo-cta-button-layout-internet-speed",
    templateUrl: "./cta-button-layout-internet-speed.component.html",
    styleUrls: ["./cta-button-layout-internet-speed.component.scss"],
    standalone: false
})
export class CtaButtonLayoutInternetSpeedComponent extends CTAButtonLayout
	implements OnInit {
	@Input() title: string;
	@Input() originalPrice: string;
	@Input() iconImage: string;
	@Input() iconImageDisabled: string;
	@Input() descriptions: string[];
	@Input() disabled = false;

	@Input() marketing: {
		text: string;
		textDecoration: string;
	};

	@Input() set context(ctx: CtaButtonLayoutInternetSpeedContext) {
		if (ctx) {
			this.__updatePropertyFromContext(ctx);
		}
	}

	set layoutContext(ctx: CtaButtonLayoutInternetSpeedContext) {
		if (ctx) {
			this.__updatePropertyFromContext(ctx);
		}
	}

	private __updatePropertyFromContext(
		ctx: CtaButtonLayoutInternetSpeedContext
	) {
		this.title = this.title || ctx.title;
		this.originalPrice = this.originalPrice || ctx.originalPrice;
		this.iconImage = this.iconImage || ctx.iconImage;
		this.iconImageDisabled = this.iconImageDisabled || ctx.iconImageDisabled;
		this.descriptions = this.descriptions || ctx.descriptions;
		this.marketing = this.marketing || ctx.marketing;
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
